var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("database-management", {
    attrs: {
      headings: _vm.headings,
      entries: _vm.entries,
      loading: _vm.loading,
      sort: _vm.sort,
      "sort-dir": _vm.sortDir,
      "show-delete": true,
    },
    on: {
      showModal: (id) => {
        _vm.selectedEntryId = id
        _vm.showModal()
      },
      updateSort: (key) => {
        _vm.updateSort(key)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "heading",
        fn: function () {
          return [_vm._v("Department Management")]
        },
        proxy: true,
      },
      {
        key: "list",
        fn: function () {
          return _vm._l(_vm.sortedEntries, function (department) {
            return _c("department-management-list-item", {
              key: department.id,
              attrs: { department: department },
              on: {
                edit: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showModal()
                },
                delete: (id) => {
                  _vm.selectedEntryId = id
                  _vm.showDeleteModal()
                },
              },
            })
          })
        },
        proxy: true,
      },
      {
        key: "modal",
        fn: function () {
          return [
            _c("department-management-modal", {
              ref: "modal",
              attrs: {
                department:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
              },
              on: {
                create: (department) => {
                  _vm.add(department)
                },
                update: (department) => {
                  _vm.update(department)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "departmentsModal",
        fn: function () {
          return [
            _c("department-management-departments-modal", {
              ref: "departmentsModal",
              attrs: {
                department:
                  _vm.selectedEntryIndex !== -1
                    ? _vm.entries[_vm.selectedEntryIndex]
                    : _vm.defaultEntry,
                departments: _vm.entries,
                users: _vm.departmentUsers,
              },
              on: {
                update: (department) => {
                  _vm.update(department)
                },
                added: (entries) => {
                  _vm.updateEntries(entries)
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }